import React from "react";
import DashboardLayout from "../layout/DashboardLayout";
import { Card, CardContent, Typography } from "@mui/material";

export default function Memberships() {
  return (
    <DashboardLayout title="Memberships">
      <Card elevation={0} sx={{ borderRadius: 2, border: "1px solid rgba(0,0,0,0.06)" }}>
        <CardContent>
          <Typography sx={{ fontWeight: 900 }}>Memberships</Typography>
          <Typography sx={{ mt: 1, opacity: 0.7 }}>Coming next.</Typography>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
